import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

export interface Event {
  eventId: number;
  eventName: string;
}

export interface AllEventsResponse {
  active: Event[];
  completed: Event[];
}

/** state */
interface EventState {
  events: AllEventsResponse | Event[];
  loading: boolean;
  error: string | null;
}

const initialState: EventState = {
  events: [],
  loading: false,
  error: null,
};

/** Async thunk */
export const fetchAllEventsList = createAsyncThunk<AllEventsResponse | Event[], string>(
  "events/fetchAllEvents",
  async (eventStatus: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`api/eventregistration/eventNamesList/${eventStatus}`);
      // return the body
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch events");
    }
  }
);

/** Slice */
const alleventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllEventsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllEventsList.fulfilled, (state, action: PayloadAction<AllEventsResponse | Event[]>) => {
        state.loading = false;
        state.events = action.payload;
      })
      .addCase(fetchAllEventsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default alleventsSlice.reducer;